"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setUrlParam = exports.setService = exports.default = void 0;

var _qs = _interopRequireDefault(require("qs"));

var _createHeaderMap = _interopRequireDefault(require("./createHeaderMap"));

var _config2 = _interopRequireDefault(require("./config"));

var _replaceHostUrl = _interopRequireDefault(require("./replaceHostUrl"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var REG_PATH = /^\/[0-9a-zA-Z]+/;
var REG_URL = /^(http:\/\/|https:\/\/|\/\/)/;
var API = {};
var services = [];
var URL_PARAMS = null; // 设置默认配置

if (_config2.default) {
  var srKeys = Object.keys(_config2.default);
  services = srKeys;
  API = _config2.default;
}

var setService = function setService(api) {
  if (!api) {
    return false;
  }

  var keys = Object.keys(api);

  if (keys.length) {
    keys.map(function (key) {
      if (!~services.indexOf(key)) {
        services.push(key);
      }

      API[key] = api[key];
      return key;
    });
  }
};

exports.setService = setService;

var setUrlParam = function setUrlParam(params) {
  URL_PARAMS = params;
};
/**
 * 增加全局参数
 * @param url 
 */


exports.setUrlParam = setUrlParam;

var addParams = function addParams(url) {
  if (URL_PARAMS && Object.keys(URL_PARAMS).length) {
    var query = Object.keys(URL_PARAMS).map(function (key) {
      return "".concat(key, "=").concat(encodeURIComponent(URL_PARAMS[key]));
    }).join('&');
    url += "".concat(!~url.indexOf('?') ? '?' : '&').concat(query);
  }

  return url;
};

var getUrl = function getUrl(params) {
  var url = params.url;
  var _params$server = params.server,
      server = _params$server === void 0 ? '' : _params$server,
      path = params.path;

  if (url) {
    url = addParams(url);

    if (REG_PATH.test(url)) {
      return url;
    }

    if (!REG_URL.test(url)) {
      return "//".concat(url);
    }

    return url;
  }

  var fetchUrl = path || '/';

  var _host = ~services.indexOf(server) ? API[server].host : '';

  if (server && _host) {
    fetchUrl = "".concat(_host).concat(path);

    if (!REG_PATH.test(_host)) {
      // _host非完整地址，自动补全“//”
      if (!REG_URL.test(_host)) {
        fetchUrl = "//".concat(_host).concat(path);
      }
    }
  } else {
    fetchUrl = path;
  }

  return addParams(fetchUrl);
};

var bodyMethod = ['POST', 'PUT', 'PATCH', 'DELETE'];

var configFn = function configFn(config) {
  var addConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (_typeof(config) === 'object') {
    config = _extends({}, addConfig, config);
  } else if (typeof config === 'string') {
    config = _extends({}, addConfig, {
      url: config
    });
  } else {
    throw new Error('Params error; Signature (url) or (config)');
  }

  var _config = config,
      url = _config.url,
      server = _config.server,
      _config$path = _config.path,
      path = _config$path === void 0 ? '' : _config$path,
      _config$method = _config.method,
      method = _config$method === void 0 ? 'GET' : _config$method,
      mode = _config.mode,
      headers = _config.headers,
      _config$withCredentia = _config.withCredentials,
      withCredentials = _config$withCredentia === void 0 ? true : _config$withCredentia,
      _config$defaultFormat = _config.defaultFormat,
      defaultFormat = _config$defaultFormat === void 0 ? true : _config$defaultFormat,
      params = _config.params,
      data = _config.data,
      configReplaceHostUrl = _config.replaceHostUrl; // 非服务配置
  // if (url) defaultFormat = false;

  var fetchUrl = getUrl({
    url: url,
    server: server,
    path: path
  }); //  IOS版本升级到14及以上，及chorme等浏览器高版本 跨站请求伪造 （CSRF） 攻击增强防御能力
  // https://developer.mozilla.org/zh-CN/docs/Web/HTTP/Headers/Set-Cookie/SameSite
  // IOS系统App内处理

  if (configReplaceHostUrl && fetchUrl) {
    fetchUrl = (0, _replaceHostUrl.default)(fetchUrl);
  }

  var fetchOptions = {
    method: method.toUpperCase(),
    mode: mode || 'cors'
  }; // 配置请求cookies携带

  if (withCredentials) {
    fetchOptions.credentials = 'include';
  }

  var headerMap = (0, _createHeaderMap.default)(); // 配置请求头

  if (headers && _typeof(headers) === 'object') {
    Object.keys(headers).forEach(function (key) {
      headerMap.set(key, headers[key]);
    });
  } // 默认json请求头


  if (headers !== false) {
    headerMap.get('Accept') || headerMap.set('Accept', 'application/json');
  }

  var isDataUsed = false; // 配置请求体

  if (!!~bodyMethod.indexOf(fetchOptions.method) && data) {
    isDataUsed = true; // 默认json请求头

    if (headers !== false && defaultFormat !== false) {
      headerMap.get('Content-Type') || headerMap.set('Content-Type', 'application/json');
    }

    var contentType = headerMap.get('Content-Type');

    if (contentType && ~contentType.indexOf('application/x-www-form-urlencoded')) {
      fetchOptions.body = _qs.default.stringify(data, {
        arrayFormat: 'repeat'
      });
    } else if (contentType && ~contentType.indexOf('application/json')) {
      fetchOptions.body = JSON.stringify(data);
    } else {
      // fetch在未设置Content-Type时，会默认根据body类型，设置默Content-Type。
      fetchOptions.body = data;
    }
  }

  var fetchConfig = {
    url: fetchUrl,
    options: fetchOptions
  };
  var query = isDataUsed ? params : params || data;

  if (query) {
    var queryString = _qs.default.stringify(query);

    fetchConfig.url = "".concat(fetchUrl, "&").concat(queryString).replace(/[&?]{1,2}/, '?');
  } // 从 headerMap 获取请求头


  fetchOptions.headers = headerMap.headers();
  return fetchConfig;
};

var _default = configFn;
exports.default = _default;